module.exports = __webpack_public_path__ + "app-static/img/user-head.a495563f.png";